import type { StepMap } from "@/components/onboarding/components/welcome-wizard";
import { NativeAppDownloadStep } from "./native-app-download-step";

export const NativeAppDownloadStepMap: StepMap = {
  "native-app-download": {
    id: "native-app-download",
    render: props => <NativeAppDownloadStep {...props} />,
  },
} as const;
